<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container style="margin-bottom: 50px;background: #fff">
      <a-form :form="form" slot="detail">
        <a-row class="form-box">
          <a-col :span="24" style="display: flex;justify-content: space-between">
            <a-form-item label="客户姓名" style="width: 48%">
              <a-input  :disabled="true"  v-decorator="['driverName', validatorRules.driverName]"  ></a-input>
            </a-form-item>
            <a-form-item label="司机号码" style="width: 48%">
              <a-input  :disabled="true"  v-decorator="['phoneb', validatorRules.phoneb]"   ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="外呼号码">
              <a-input  :disabled="true"  v-decorator="['phonex', validatorRules.phonex]"
                        style="height: 96px !important;background: #feeaec !important;font-size: 38px !important;text-align: center !important;" ></a-input>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item label="我的号码">
              <a-input  :disabled="true"  v-decorator="['phonea', validatorRules.phonea]"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="号码状态">
              <j-dict-select-tag :disabled="formDisabled" type="list" v-decorator="['phrases', validatorRules.phrases]" :trigger-change="true" dictCode="phone_status_dic" placeholder="请选择号码状态" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="备注">
              <a-textarea  :disabled="formDisabled"   v-decorator="['remark', validatorRules.remark]" rows="4" placeholder="请输入备注" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import Vue from 'vue'
  import { formatSearchConetnt,by_str } from '@/utils/util'
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import {initDictOptions, filterDictText} from '@/components/dict/JDictSelectUtil'
  import ACol from "ant-design-vue/es/grid/Col";
  export default {
    name: 'DmWorkOrderForm',
    components: {
      ACol
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {

        },
        url: {
          add: "/dm/dmCallAxb/saveCallAndUnBindAxb"
        },ccList:[],
        dictOptionsType:{},
        workorder_phrases:[],
        formatSearchConetnt:formatSearchConetnt,
        phrases:'',
        parentList:[],
        typeChildList:[]
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {

    },watch(){

    },
    methods: {
       add (record) {
         if(!record.phrases){
           record.phrases = "正常"
         }
         this.$store.dispatch('ToggleCallStatus', 0)
        this.edit(record);
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'driverName','phonex','phoneb','phonea','phrases','phrases','remark'))
        })
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
              httpurl+=this.url.add;
              method = 'post';
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok',res.result);
                let p = Vue.ls.get("CALL_RECORD");
                if(p){
                  Vue.ls.remove("CALL_RECORD");
                }
                this.$store.dispatch('ToggleCallStatus', 2)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'driverName','phonex','phoneb','phonea','phrases','phrases','remark'))
      },saveHc(){
        // 触发表单验证
        this.form.validateFields((err, values) => {
          let formData = Object.assign(this.model, values);
          httpAction("/dm/dmCallZxh/add",{
            callData:formData
          },"POST").then(res=>{
            if(res.success){
              Vue.ls.set("CALL_RECORD", formData, 7*24 * 60 * 60 * 1000);
              //this.$root.$callStatus=1;
              this.$store.dispatch('ToggleCallStatus', 1)
            }
          });
        })
      }
    }
  }
</script>
<style lang="less" scoped>

  /deep/ .ant-col-xs-24{
    float: inherit;
  }
  /deep/ .ant-form-item{
    margin-bottom: 0px !important;
  }

  .form-box{
    padding:24px;
  }
  .phrases-box{
    max-height: 400px;
    background:rgba(255, 255, 255, 1);
    color: rgba(56, 56, 56, 1);
    margin-top: -10px;
    padding-top: 10px;

  }
  .phrases-box div{
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    cursor: pointer;
  }
  /deep/ .ant-input-disabled.ant-input{
    background: rgb(244, 249, 253) !important;
  }
</style>